import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/ScrollReveal';
import WhatsAppButton from '@/components/WhatsAppButton';
import { ArrowRight, Phone } from 'lucide-react';

export default function CampaignCTA() {
  return (
    <section className="py-16 md:py-32 bg-secondary/30">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="bg-navy text-white rounded-3xl px-6 py-16 md:px-16 md:py-24 text-center">
            <p className="caps-label text-orange mb-6">Detailed, photographic inventory reports</p>
            <h2 className="font-display font-extrabold mono-number max-w-3xl mx-auto" style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}>
              Protect your property.<br />Protect your deposit.
            </h2>
            <p className="text-lg text-white/70 mt-6 max-w-xl mx-auto">
              Call us now or request a quote online — it takes less than two minutes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
              <Link to="/request-quote" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-orange text-navy font-semibold rounded-full hover:bg-orange-dark transition-colors">
                Request Quote <ArrowRight size={20} />
              </Link>
              <a href="tel:02089355492" className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-white/30 text-white font-semibold rounded-full hover:bg-white/10 transition-colors">
                <Phone size={18} /> 0208 935 5492
              </a>
              <WhatsAppButton label="Chat on WhatsApp" />
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}